import {
  Component,
  EventEmitter,
  Output
} from '@angular/core';

import * as _ from 'lodash';

import {RequestsServices} from '../../../../../services/requests.service';
import {UserService} from '../../../../../services/user.service';
import {StorageService} from '../../../../../services/storage.service';
import {PageBase} from '../../../../../page.base';
import {ToasterService} from '../../../../../services/toaster.service';
import { AccountsService } from 'src/app/services/accounts.service';

@Component({
  selector: 'app-colabs-table',
  providers: [RequestsServices, StorageService, UserService, AccountsService],
  templateUrl: './colabs-table.component.html',
})

export class ColabsTableComponent extends PageBase {

  public isLoading = false;
  private establishmentId: string;
  private companyId: string;
  public typeBusiness: string;

  @Output() public rowsCountEvent = new EventEmitter<Object>();
  @Output() public countUnivited = new EventEmitter<Object>();
  @Output() public countInactive = new EventEmitter<Object>();
  @Output() public unblockButtons = new EventEmitter<Object>();
  @Output() public haveEmail = new EventEmitter<boolean>();
  @Output() public closeModalGroup = new EventEmitter<boolean>();

  public rows = [];
  public rowsOriginalCollection = [];
  public rowsByStatus = [];
  public selected = [];
  public loadingIndicator = true;
  public rowsCount = 0;
  public fetchRowsState;
  public offset = 0;
  public sorts = 'customer.lastActivity asc';
  public filtersParams = {};

  constructor(private toasterService: ToasterService,
              private request: RequestsServices,
              private storage: StorageService,
              private userService: UserService,
              private accountService: AccountsService) {
    super();
    const loggedAccount = this.userService.getLoggedAccount();
    this.typeBusiness = this.userService.getTypeAccount();

    if (this.typeBusiness === 'company') {
      this.companyId = loggedAccount.id;
    } else if (this.typeBusiness === 'establishment') {
      this.establishmentId = loggedAccount.id;
    } else {
      alert('Falha ao recuperar dados.');
    }
  }

  private getNameFilterCondition(name) {
    if (!name) {
      return null;
    }

    name = name.trim();
    const nameArray = name.split(' ');

    if (nameArray.length > 1) {
      const firstName = nameArray[0];
      nameArray.splice(0, 1);
      const surname = nameArray.join(' ');
      return { and: [ { first_name: { like: firstName, options: 'gi' } }, { surname: { like: surname, options: 'gi' } } ]};
    }

    return { first_name: { like: name, options: 'gi' } };
  }

  public fetchRowsAdvancedSearch(params: any = {}): void {
    if (!_.isEmpty(params)) {
      this.clearSelected();
      this.offset = 0;
      this.filtersParams = params;
    } else {
      params = this.filtersParams;
    }

    const name = params.advancedFilter.name;
    const email = params.advancedFilter.email;
    const cpf = params.advancedFilter.cpf.replace(/\.|-/g, '');
    const employeeRegistrationNumber = params.advancedFilter.employeeRegistrationNumber;

    let profiles = params.params.filterProfile;
    const status = params.params.filterStatus;
    let unit = params.params.filterUnit;

    const filterObject: any = {
      skip: this.offset * 10,
      order: 'first_name asc',
      where: {
        and: []
      },
      include: ['customer', 'cost_center']
    };

    if (this.userService.getTypeAccount() === 'company') {
      filterObject.where.and.push({companyId: this.companyId});
    } else {
      filterObject.where.and.push({establishmentId: this.establishmentId});
    }

    const nameWhere = this.getNameFilterCondition(name);
    if (nameWhere) {
      filterObject.where.and.push(nameWhere);
    }

    if (email) {
      filterObject.where.and.push({and: [{email: {like: email, options: 'gi'}}]});
    }

    if (cpf) {
      filterObject.where.and.push({and: [{cpf: {like: cpf, options: 'gi'}}]});
    }

    if (employeeRegistrationNumber) {
      filterObject.where.and.push({and: [{employeeRegistrationNumber: {like: employeeRegistrationNumber, options: 'gi'}}]});
    }

    if (profiles.length > 0) {
      profiles = profiles.map((profile) => profile.toString());
      const profilesToSearch = {profilesId: {inq: profiles}};
      filterObject.where.and.push(profilesToSearch);
    }

    if (status.length > 0) {
      const statusToSearch = {status: {inq: status}};
      filterObject.where.and.push(statusToSearch);
    }

    if (unit.length > 0) {
      unit = unit.map((unitMap) => unitMap.toString());
      const unitToSearch = {costCenterId: {inq: unit}};
      filterObject.where.and.push(unitToSearch);
    }

    this.isLoading = true;
    this.request.post('accountsPagination', filterObject).then((result) => {
      const {items, counters} = result;
      this.isLoading = false;
      this.rows = items;
      this.rows = this.formatRows(this.rows);
      this.rowsCount = counters.itemsTotal;
      this.setRowsCount();
    }, (err) => {
      this.isLoading = false;
    });

  }

  public fetchRows(params: any = {}): void {
    this.fetchRowsState = params;

    if (params.isSimpleSearch && this.rowsOriginalCollection.length > 0 && !params.forceReload) {
      // This means that the grownMetricsRows are already fetched
      this.isLoading = false;
      this.filterRows(params);
      return;
    }

    const filter: any = {
      where: {
        and: []
      },
      include: ['customer', 'cost_center'],
      order: this.sorts
    };

    if (this.userService.getTypeAccount() === 'company') {
      filter.where.and.push({companyId: this.companyId});
    } else {
      filter.where.and.push({establishmentId: this.establishmentId});
    }

    this.isLoading = true;
    this.request.post('accountsPagination', filter).then((response) => {
      const {items, counters} = response;
      this.isLoading = false;
      const data = items;

      this.loadingIndicator = false;
      this.rowsOriginalCollection = data;
      this.rowsCount = counters.itemsTotal;
      this.setRowsCount();
      this.setCountUnivited();
      this.setCountInactive();
      this.rows = this.formatRows(data);
      this.filterRows(this.fetchRowsState);

      this.clearSelected();

      this.fetchRowsState.forceReload = false;
    }, (err) => {
      this.clearSelected();
      this.isLoading = false;
    });
  }

  public formatRows(rows): any {
    return rows.map((row) => {
      row.name = row.first_name + ' ' + row.surname;
      row.group = row.cost_center ? row.cost_center.name : 'Nenhum';
      row.lastActivity = row.customer ? row.customer.lastActivity : null;
      row.firstAccess = row.customer ? row.customer.firstAccess : null;
      row.created_date = row.customer ? row.customer.created_at : null;
      return row;
    });
  }

  public onSelect() {
    if (this.selected.length) {
      this.unblockButtons.emit(true);
    } else {
      this.unblockButtons.emit(false);
    }

    this.haveEmailSelected();
  }

  public onPage($event) {
    this.offset = $event.offset;
    this.fetchRowsAdvancedSearch();
  }

  public onSort({ sorts }) {
    let {prop, dir} = _.first(sorts);

    if (prop === 'name') {
      prop = 'first_name';
    }

    this.sorts = `${prop} ${dir}`;

    this.fetchRowsAdvancedSearch();
  }

  public getId(row) {
    return row.id;
  }

  public clearSelected(): void {
    this.selected = [];
    this.unblockButtons.emit(false);
  }

  public setRowsCount(): void {
    this.rowsCountEvent.emit(this.rowsCount);
  }

  public setCountUnivited(): void {
    const filter = {
      where: {
        and: []
      }
    };

    filter.where.and.push({status: 'not_invited'});
    filter.where.and.push({email: {exists: true}});
    filter.where.and.push({email: {ne: null}});
    filter.where.and.push({email: {ne: ''}});

    if (this.userService.getTypeAccount() === 'company') {
      filter.where.and.push({companyId: this.companyId});
    } else {
      filter.where.and.push({establishmentId: this.establishmentId});
    }


    const createParameters = [{
      param: 'filter',
      value: JSON.stringify(filter)
    }];

    this.request.get({path: 'accounts', endPoint: '/', params: createParameters}).then((employeesInactive) => {
      this.countUnivited.emit(employeesInactive);
    });
  }

  public setCountInactive(): void {
    const today = new Date();
    const priorDate = new Date().setDate(today.getDate() - 30);

    const filter = {
      where: {
        and: []
      },
      include: [{
        relation: 'customer',
        scope: {
          where: {
            and: [
              {lastActivity: {eq: null}},
              {email: {neq: null}}
            ]
          }
        }
      }]
    };

    filter.where.and.push({status: 'not_invited'});
    filter.where.and.push({inviteSentDate: {gt: priorDate}});

    if (this.userService.getTypeAccount() === 'company') {
      filter.where.and.push({companyId: this.companyId});
    } else {
      filter.where.and.push({establishmentId: this.establishmentId});
    }

    const createParameters = [{
      param: 'filter',
      value: JSON.stringify(filter)
    }];

    this.request.get({path: 'accounts', endPoint: '/', params: createParameters}).then((employeesInactive) => {
      this.countInactive.emit(employeesInactive);
    });
  }

  public filterRows(params: any = {}): any {
    if (('params' in params)
      && 'filterStatus' in params.params
      && params.params.filterStatus !== '') {
      this.rowsByStatus = this.filterRowsByStatus(params);
      if (('params' in params)
        && 'filterRows' in params.params
        && params.params.filterRows !== '') {

        this.rows = this.filterRowsByAttributes(params, this.rowsByStatus);
      } else {
        this.rows = this.rowsByStatus;
      }
    }
  }

  public filterRowsByAttributes(params: any = {}, rowsByStatus: any): any {

    const rows = rowsByStatus.filter(item => {

      const value = params.params.filterRows;
      const values = value.split(' ');

      // Remove empty string
      for (let i = 0; i < values.length; i++) {
        if (values[i].trim() === '') {
          values.splice(i, 1);
        }
      }

      let regexString = '';
      if (values.length > 0) {
        for (let i = 0; i < values.length; i++) {
          regexString += values[i].trim();
          if (i < (values.length - 1) && values[i].trim() !== '') {
            regexString += '|';
          }
        }
      }

      const reg = new RegExp(regexString, 'gi');

      const myEmployeeCpf = item.cpf || '';
      let myEmployeeCpfWithouMask = '';
      if (item.cpf) {
        myEmployeeCpfWithouMask = item.cpf.replace(/\.|-/g, '');
      }

      return !item.name ? false : item.name.match(reg) || (!myEmployeeCpf ? false : myEmployeeCpf.match(reg) ||
        !item.email ? false : item.email.match(reg) || !myEmployeeCpfWithouMask ? false : myEmployeeCpfWithouMask.match(reg));

    });

    return rows;
  }

  public filterRowsByStatus(params: any = {}): any {
    const rows = this.rowsOriginalCollection.filter(item => {

      const values = params.params.filterStatus;
      const employeeStatus = item.status;

      if (values.length > 0) {
        if (values.includes(employeeStatus)) {
          return true;
        }
      } else {
        return false;
      }
    });

    return rows;
  }


  public haveEmailSelected(): void {
    let countEmail = 0;
    let haveEmailSelected;

    this.selected.forEach(item => {
      if (item.email) {
        countEmail += 1;
      }
    });

    haveEmailSelected = !!countEmail;
    this.haveEmail.emit(haveEmailSelected);
  }

  public sendInvitationToSelected(): void {
    const accountsIds = this.selected.map((employee) => employee.id);
    this.isLoading = true;

    this.request.post('customers', {accountsIds}, 'sendInvitation').then(() => {
      this.fetchRows({...this.fetchRowsState, forceReload: true});
      this.toasterService.info('Sucesso!', 'Convites reenviados para os funcionários selecionados.', false, 4000);
    }, () => {
      this.isLoading = false;
      this.toasterService.info('Oops!',
        'Não foi possível enviar os convites para os funcionários. Tente novamente mais tarde.', false, 4000);
    });
  }

  public unlockSelected(): void {
    const accountsIds = this.selected.map((employee) => employee.id);
    this.isLoading = true;

    this.request.post('customers', {accountsIds}, 'unblockEmployees').then(() => {
      this.fetchRows({...this.fetchRowsState, forceReload: true});
      this.toasterService.info('Sucesso!', 'Funcionários desbloqueados com sucesso.', false, 4000);
    }, () => {
      this.isLoading = false;
      this.toasterService.info('Oops!',
        'Não foi possível desbloquear os funcionários selecionados no momento. Tente novamente mais tarde.', false, 4000);
    });
  }

  public blockSelected(): void {
    const accountsIds = this.selected.map((employee) => employee.id);
    this.isLoading = true;

    this.request.post('customers', {accountsIds}, 'blockEmployees').then(() => {
      this.fetchRows({...this.fetchRowsState, forceReload: true});
      this.toasterService.info('Sucesso!', 'Bloqueamos os funcionários selecionados.', false, 4000);
    }, () => {
      this.isLoading = false;
      this.toasterService.info('Oops!',
        'Não foi possível bloquear os funcionários selecionados no momento. Tente novamente mais tarde.', false, 4000);
    });
  }

  public sendInvitation(endpointName: string): void {
    const data = {companyId: this.companyId};
    this.isLoading = true;
    this.request.post('customers', data, endpointName).then(() => {
      this.fetchRows({...this.fetchRowsState, forceReload: true});
      this.userService.requestAccountConfig();
      this.toasterService.info('Sucesso!',
      `O envio dos convites foi agendado com sucesso.<br>
      <b>ATENÇÃO:</b> Dependendo da quantidade de colaboradores o envio dos convites pode demorar alguns minutos para ser concluído.<br>
      Lembre-se, os colaboradores sem email cadastrado não serão convidados.`, false, 15000);
    }, (err) => {
      const { error } = (err && err._body) ? JSON.parse(err._body) : { error: null };

      if (error && error.message && error.message === 'INVITATIONS.ALREADY.SENT') {
        this.toasterService.info('Oops!', 'O envio de convites em massa é limitado em 1 envio a cada 3 horas.', false, 6000);
      } else {
        this.toasterService.info('Oops!', 'Não conseguimos enviar o convite. Tente novamente mais tarde.', false, 6000);
      }

      this.isLoading = false;
      this.userService.requestAccountConfig();
    });
  }

  public sendInvitationAgain(): void {
    const data = {companyId: this.companyId};
    this.isLoading = true;
    this.request.post('customers', data, 'sendInvitationAgain').then(() => {
      this.fetchRows({...this.fetchRowsState, forceReload: true});
      this.toasterService.info('Sucesso!', 'O reenvio dos convites foi agendado com sucesso.<br><br><b>ATENÇÃO:</b> Dependendo da quantidade de colaboradores o envio dos convites pode demorar alguns minutos para ser concluído.</br>', false, 15000);
    }, () => {
      this.isLoading = false;
      this.toasterService.info('Oops!', 'Não conseguimos reenviar os convites. Tente novamente mais tarde.', false, 4000);
    });
  }

  public saveAccountsGroup(costCenterId): void {
    const data = { accountsIds: this.selected.map(res => res.id), costCenterId };
    this.isLoading = true;

    this.accountService.updateAccountsGroup(data).then(() => {
      this.fetchRows({ ...this.fetchRowsState, forceReload: true });
      this.toasterService.info('Sucesso!', 'Grupo das contas atualizados.', false, 4000);
    }, () => {
      this.isLoading = false;
      this.toasterService.info('Oops!', 'Não foi possível atualizar as contas.', false, 4000);
    });

    this.closeModalGroup.emit(true);
  }

}
